import React from 'react';
import { Smartphone } from 'lucide-react';
import '../styles/LoadingScreen.css';

const LoadingScreen = ({ translations, language }) => {
  const t = translations[language];

  return (
    <div className="loading-container">
      <div className="loading-content">
        <Smartphone className="loading-icon" />
        <p>{t.loadingPhoneData}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;